import { render, staticRenderFns } from "./monitortk.vue?vue&type=template&id=18691b86&scoped=true&"
import script from "./monitortk.vue?vue&type=script&lang=js&"
export * from "./monitortk.vue?vue&type=script&lang=js&"
import style0 from "./monitortk.vue?vue&type=style&index=0&id=18691b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18691b86",
  null
  
)

export default component.exports